module.exports = __webpack_public_path__ + "img/29.ef6a135f.jpg";